import { SchoolService, BaseService } from "@/services/school.service";

function PupilFilter(years, group, types, title, tags) {
    this.years = years;
    this.group = group;
    this.types = types;
    this.title = title;
    this.tags = tags;
}

const PupilService = {
    getAll () {
        return SchoolService.getAll("pupils?page=0&results_per_page=all")
    },

    getWithFilter(filterValues, page, pageSize) {

        // group
        let group = (filterValues.group != undefined && filterValues.group.id > 0) ? "&class=" + filterValues.group.name.toLowerCase() : ""

        // years
        let years = filterValues.years != undefined ? "&yeargroups=" + filterValues.years.join() : ""

        // types
        let types = filterValues.types != undefined ? "&types=" + filterValues.types.join() : ""

        // title
        let title = filterValues.title != undefined ? "&title=" + filterValues.title.toLowerCase() : ""

        // tags 
        var tags = ""
        if (filterValues.tags != undefined && filterValues.tags.length > 0) {
            let results = filterValues.tags.substring(0,50).replaceAll("#", "").split(' ').join(',').split(',')
            tags = "&tags=" + results
        }


        return SchoolService.getAll("pupils?page=" + page + "&results_per_page=" + pageSize + group + years + types + title + tags )
    },

    add(payload) {
    	return SchoolService.create("pupils", payload)
    },

    update(result) {
    	return SchoolService.update("pupils", result.identifier, result)
    },

    delete(result) {
    	return SchoolService.delete("pupils", result.identifier, null)
    },

    getClasses() {
        return SchoolService.getAll("classes")
    },

    updateClass(payload) {
        return SchoolService.create("classes", payload)
    },
     
}

export { PupilService, PupilFilter };
